import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangePrivacyPolicy extends ChangeBusinessDetails {
  type: string = 'ChangePrivacyPolicy';
}
